import React from 'react';
import { useTranslation } from 'react-i18next';
import './HomePage.css';
import {useNavigate} from "react-router-dom";
import InstagramFeed from '../components/InstagramFeed/InstagramFeed';

export default function HomePage() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const handleBuyNow = () => {
        window.scrollTo(0, 0);
        navigate('/category/laptop-cases');
    };
    
    const handleLearnMore = () => {
        window.scrollTo(0, 0);
        navigate('/about-selezium');
    };
    
    const scrollToInstagram = () => {
        document.querySelector('.follow-us').scrollIntoView({ 
            behavior: 'smooth' 
        });
    };

    return (
        <div className="homepage-container">
            {/* Hero Banner */}
            <section className="hero-banner">
                <div className="hero-text">
                    <h1>{t('home.bannerTitle')}</h1>
                    <p>{t('home.bannerSubtitle')}</p>
                    <button className="shop-btn" onClick={handleBuyNow}>{i18n.language === 'ua' ? t('home.buyNow') : 'Shop Now'}</button>
                </div>

                <div className="hero-image">
                    <img
                        src="/images/values_banner.JPG"
                        alt="Models with Bags"
                        loading="eager"
                    />
                </div>
            </section>

            {/* The Selezium World */}
            <section className="selezium-world" id="selezium-section">
                <div className="selezium-world-inner">
                    <div className="selezium-world-text">
                        <h2>
                            THE <span>SELEZIUM</span><br/>WORLD
                        </h2>
                        <p className="world-subtitle">{t('home.theWorldSubtitle')}</p>
                        <button className="learn-more-btn" onClick={handleLearnMore}>{t('home.learnMore')}</button>
                    </div>
                    <div className="selezium-world-images">
                        <div className="world-img-left">
                            <img
                                src="/images/homepage_selezium_world_small.png"
                                alt="Brown bag"
                                loading="lazy"
                            />
                        </div>
                        <div className="world-img-right">
                            <img
                                src="/images/homepage_selezium_world_big.jpg"
                                alt="Model with bag"
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Glamour Style */}
            <section className="glamour-style">
                {/* Для мобільного: зображення зверху, текст внизу */}
                <div className="glamour-right-img mobile-first">
                    <img
                        src="/images/homepage_glamour_style.JPG"
                        alt="Model in purple jacket"
                        loading="lazy"
                    />
                </div>
                {/* Текстова частина (на десктопі зліва, на мобільному знизу) */}
                <div className="glamour-text">
                    <p className="limited-edition">{t('home.glamourTitle')}</p>
                    <h2>
                        {i18n.language === 'ua' ? (
                            <>GLAMOUR<br/>STYLE</>
                        ) : (
                            <>GLAMOUR STYLE</>
                        )}
                    </h2>
                    <button className="check-more-btn" onClick={handleBuyNow}>
                        {t('home.glamourBtn')}
                    </button>
                </div>
                {/* Стрілка для десктопу */}
                <div className="glamour-arrow desktop-only" onClick={scrollToInstagram} role="button" tabIndex="0" aria-label="Scroll to Instagram">
                    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 10 L110 110 M110 110 L110 15 M110 110 L15 110" stroke="white" strokeWidth="5"/>
                    </svg>
                </div>
                {/* Для десктопу: фото справа */}
                <div className="glamour-right-img desktop-only">
                    <img
                        src="/images/homepage_glamour_style.JPG"
                        alt="Model in purple jacket"
                        loading="lazy"
                    />
                </div>
            </section>

            {/* Instagram Feed Section */}
            <section className="follow-us">
                <InstagramFeed />
            </section>
        </div>
    );
}
